<template>
  <button @click="$emit('clicked')" type="button" class="btn btn-outline-main px-4">
    {{ $t(`listing.${value ? "close" : "open"}`) }}
    <b-icon
      :icon="`chevron-${value ? 'up' : 'down'}`"
      class="ml-1"
      style="width: 15px"
    ></b-icon>
  </button>
</template>

<script>
export default {
  name: "SectionButton",
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
